import React, {useState,useContext} from 'react'
import {dataContext,localestr} from '../utils.js'

export default function WndBottling({action,is_liter=false}){
    const context=useContext(dataContext)
    const close_msg=context.clsTWnd

    const [val1, setVal1] = useState(is_liter?1:0.5)
    const [val2, setVal2] = useState(50)
    return(
        <div style={{maxWidth:'250px'}}>
        <div>{localestr('Об\'єм пляшки з якої здійснюється розлив')}  <select style={{width:'100px',height:'24px'}} disabled={is_liter} value={val1} onChange={(e)=>{setVal1(e.target.value)}}>
        <option value={0.33}>0.33 {localestr('л.')}</option>
        <option value={0.5}>0.5 {localestr('л.')}</option>
        <option value={0.7}>0.7 {localestr('л.')}</option>
        <option value={0.75}>0.75 {localestr('л.')}</option>
        <option value={1}>1.0 {localestr('л.')}</option>
        </select></div>
        <div style={{marginTop:'20px'}}>{localestr('Об\'єм одної порції')}  <select style={{width:'100px',height:'24px'}} value={val2} onChange={(e)=>{setVal2(e.target.value)}}>
        <option value={25}>25 {localestr('мл.')}</option>
        <option value={50}>50 {localestr('мл.')}</option>
        <option value={100}>100 {localestr('мл.')}</option>
        <option value={200}>200 {localestr('мл.')}</option>
        <option value={250}>250 {localestr('мл.')}</option>
        <option value={330}>330 {localestr('мл.')}</option>
        <option value={500}>500 {localestr('мл.')}</option>
        </select></div>
        <div style={{marginTop:'20px'}}>{localestr('Немає необхідного дозування?')}</div>
        <div style={{marginTop:'5px'}}>{localestr('Знайдіть його самостійно, розділивши об\'єм одної порції на об\'єм пляшки з якої здійснюється розлив.')}</div>
        <div className='no-print' style={{margin:'10px 0 0 0',maxWidth:'250px',display:'flex',justifyContent:'center',flexGrow:'100000'}}>
        <div style={{width:'54px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{action(parseInt(val2*10/val1)/10000);close_msg()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
        </div>
        </div>
    )

}